angular.module('cerberus.util')
    .factory('checkPrintingService', function(_, kendo, $compile, $http, $q, $rootScope, $location, $timeout, $window, DeviceSniffService){
        var service = {
            printChecks: printChecks
        };

        return service;

        /**
         * Prints checks from the specified instances
         * @param instanceIds
         * @param checkOptions - options set by user in the print configuration modal
         * @param checkOptions.targetForm - originator ID of the form of type "check" that will be printed
         * @param checkOptions.pageCounter - model ID of the form field that will contain the check number
         * @param checkOptions.checksPerPage - number of checks that will be printed on each page
         * @param checkOptions.checkNumbers - map of check numbers assigned to each instance
         * @param checkOptions.checkNumExists - map of check numbers restricted to be updated (Record detected and preserved)
         * @param checkOptions.carbonCopy - if true, each page will be printed twice
         * @param [formData] - Loaded form data passed in from an open instance
         * @param [autoFillData] - Loaded autofill data passed in from an open instance
         */
        function printChecks(instanceIds, filename, checkOptions, formData, autoFillData){
            var element,
                deferred = $q.defer(),    
                printSection = angular.element('#print-build-section'),
                checkScope = $rootScope.$new(true),
                paperOptions = kendo.pdf.getPaperOptions(angular.copy(checkOptions)),
                template = '<div nim-check-builder></div>';

            // Set scope variables
            checkScope.instanceIds = instanceIds;
            checkScope.formOriginId = _.last(checkOptions.targetForm.split('-'));
            checkScope.pageCounter = checkOptions.pageCounter;
            checkScope.checksPerPage = checkOptions.checksPerPage;
            checkScope.checkNumbers = checkOptions.checkNumbers;
            checkScope.checkNumExists = checkOptions.checkNumExists;
            checkScope.carbonCopy = checkOptions.carbonCopy;
            checkScope.paperOptions = paperOptions;
            checkScope.formData = {};

            if(!_.isEmpty(formData)) {
                checkScope.formData = formData;
            }

            if(!_.isEmpty(autoFillData)) {
                checkScope.autoFillData = autoFillData;
            }

            // Load CSS
            var cssLink = angular.element($window.document).find('link[rel=stylesheet]');
            var cssPromise = null;
            if (cssLink[0]) {
                cssPromise = $http.get(cssLink[0].href);
            }

            // Called by check-building directive when the checks have been loaded
            checkScope.done = function() {
                checkScope.$destroy();

                var browser = DeviceSniffService.deviceBrowser(),
                    isIE = _.startsWith(browser, 'IE'),
                    printWindow = null;
                
                if (!isIE) {
                    printWindow = $window.open();
                }

                // If Internet Explorer, download pdf
                if (isIE || !printWindow) {
                    exportPDF(element, paperOptions).done(function (dataURI) {
                        printSection.empty();

                        kendo.saveAs({
                            dataURI: dataURI,
                            fileName: filename + '.pdf'
                        });

                        deferred.resolve();
                    });
                }
                else {
                    deferred.resolve();

                    // Else, open in new window
                    printInWindow(element, printWindow, filename, cssPromise);
                    printSection.empty();
                }
            };

            element = $compile(template)(checkScope);

            printSection.empty()
                .append(element);
            
            return deferred.promise;
        }

        /**
         * Exports the rendered element to a PDF
         * @param element {jQuery}
         * @param paperOptions {Object}
         */
        function exportPDF(element, paperOptions) {
            // Check necessary page size and create printing options
            var checks = element.find('.nim-check-form'),
                pageHeight = pixelsToInteger(paperOptions.paperSize[1]),
                pageWidth = pixelsToInteger(paperOptions.paperSize[0]),
                options = {
                    forcePageBreak: '.nim-page-break',
                    paperSize: [pageWidth, pageHeight],
                    margin: {
                        top: paperOptions.margin.top,
                        bottom: paperOptions.margin.bottom
                    }
                };

            // Make sure each check stays this height
            checks.css('height', checks.height());

            return kendo.drawing.drawDOM(element, options).then(function (group) {
                return kendo.drawing.exportPDF(group, options);
            });
        }

        /**
         * Opens new window to print rendered element
         * @param element {jQuery}
         */
        function printInWindow(element, printWindow, filename, cssPromise) {
            var printContent = element.children().clone(),
                base = $location.protocol() + '://' + $location.host(),
                // cssLinks = angular.element($window.document).find('link[rel=stylesheet]').clone(),
                windowHead = angular.element(printWindow.document.head),
                windowBody = angular.element(printWindow.document.body);

            windowHead
                .append('<title>' + filename + '</title><base href="' + base + '" />');
                // .append('<title>' + filename + '</title><base href="' + base + '" />')
                // .append(cssLinks);
            
            windowBody
                .addClass('nim-print-window-body')  
                .css('padding', '0')
                .css('overflow', 'visible');
            
            windowBody.append(printContent);

            if (cssPromise) {
                cssPromise.then(function (result) {
                    var style = angular.element('<style type="text/css">' + result.data + '</style>');
                    style[0].onload = function () {
                        executePrint();
                    };
                    windowHead.append(style);
                });
            }
            else {
                executePrint();
            }
            
            function executePrint() {
                $timeout(function () {
                    printWindow.document.close();
                    printWindow.focus();
                    printWindow.print();
                }, 1);
            }
        }

        /**
         * Takes string of format "0px", removes "px" and returns the number
         * @param pixelString
         * @returns {*|number}
         */
        function pixelsToInteger(pixelString) {
            var valueString = pixelString.replace('px', '');
            return parseInt(valueString);
        }
    })
;